<template>
    <div class="bg-img">
        <div class="flex w-full middle">
            <div class="vx-col sm:w-1/3 md:w-1/3 lg:w-1/4 xl:w-2/5 mx-auto self-center" >
                <div slot="no-body">
                    <vs-row>
                        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                            <vs-input
                                name="password"
                                :label="$t('message.newPwd')"
                                v-model="passwd"
                                type="password"
                                class="no-icon-border" style="width: 300px"/>
                        </vs-col>
                    </vs-row>
                    <vs-row class="m-t-2">
                        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                            <vs-input
                                name="repassword"
                                :label="$t('message.newRePwd')"
                                v-model="repasswd"
                                type="password"
                                class="no-icon-border" style="width: 300px"/>
                        </vs-col>
                    </vs-row>

                    <vs-row class="m-t-2">
                        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                            <vs-button size="small" @click="onReset()" :disabled="!(passwd && repasswd)">{{$t('message.send')}}</vs-button>
                        </vs-col>
                    </vs-row>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from "vuex";
    export default {
        data() {
            return {
                passwd: '',
                repasswd: '',
                error: false,
                langOpt:[
                    {
                        text:'English',
                        value:'en'
                    },
                    {
                        text:'繁體中文',
                        value:'zh'
                    },
                    {
                        text:'简体中文',
                        value:'zh_cn'
                    }
                ],
                lang:'',

            }
        },
        created() {
            this.$vs.loading.close()
            this.lang = this.$cookies.get('lang');
        },
        computed: {
            ...mapGetters(["currentUser"])
        },
        watch:{
            currentUser: function (val) {
                if (this.$cookies.get('login') && this.$cookies.get('token') && this.$cookies.get('role')) {
                    if (val.role === 'admin') {
                        this.$router.push({path: '/account_staff'});
                    } else if (val.role === 'user') {
                        this.$router.push({path: '/'});
                    } else {
                        this.$router.push({path: '/customer'});
                    }
                }
            }
        },
        methods:{
            ...mapActions(["getUser"]),
            onReset(){
                if(this.passwd !== this.repasswd){
                    return this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.pwdError'),
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
                this.$vs.notify({
                    title:'提示',
                    text: this.$t('message.setPwd'),
                    icon: 'done',
                    color:'success',
                    position:'top-center',
                    time: 3000
                });


                // let url = process.env.VUE_APP_API_BASEURL + '/api/auth/forget';
                // fetch(url,{
                //     method: 'post',
                //     headers: {
                //         'Accept': 'application/json, text/plain, *!/!*',
                //         'Content-Type': 'application/json'
                //     },
                //     body: JSON.stringify({
                //         email: '',
                //         passwd: ''
                //     })
                // }).then((response)=>{
                //     return response.json()
                // }).then((res)=>{
                //     console.log(res)
                //     if(res.responseCode === 200){
                //         this.$cookies.set('token', res.responseDetail.token, 60 * 30 * 30)
                //         this.$cookies.set('login', true, 60 * 30 * 30)
                //         this.getUser({
                //             token: res.responseDetail.token
                //         })
                //     }else{
                //         this.$vs.notify({
                //             title:'提示',
                //             text: this.$t('message.errorMsg'),
                //             icon: 'clear',
                //             color:'danger',
                //             position:'top-center',
                //             time: 3000
                //         });
                //     }
                // })
            },
        }
    }
</script>

<style lang="scss">
    .middle{
        width: 100%;
        height: 62vh;
        background-color: rgba(255, 255, 255, 0.4);
    }
</style>
